import { useState } from "react";

export const useCurrentlyEditing = () => {
  const [currentlyEditing, setCurrentlyEditing] = useState<
    | "time"
    | "title"
    | "description"
    | "schedule"
    | "duration"
    | "endDate"
    | "requiredCompetences"
    | "doubleStaffing"
    | "hidden"
    | "measurements"
    | "move"
    | "invoicingCodes"
    | "note"
    | null
  >(null);

  return { currentlyEditing, setCurrentlyEditing };
};
